import { createSlice } from '@reduxjs/toolkit'
import { fetchNegotiationHistoryAsync } from '../asyncThunks/negotiationHistory'
import { initialState } from '../initialState/negotiationHistory'

const negotiationHistorySlice = createSlice({
  name: 'negotiationHistory',
  initialState,
  reducers: {
    resetMessages: (state) => {
      state.messages = []
      state.currentPage = 1
      state.hasMore = true
      state.totalCount = 0
    },
    setLoadingMore: (state, action) => {
      state.loadingMore = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNegotiationHistoryAsync.pending, (state, action) => {
        if (action.meta.arg.reset || action.meta.arg.page === 1) {
          state.loading = true
          state.loadingMore = false
        } else {
          state.loading = false
          state.loadingMore = true
        }
        state.error = null
      })
      .addCase(fetchNegotiationHistoryAsync.fulfilled, (state, action) => {
        state.loading = false
        state.loadingMore = false
        state.negotiationId = action.payload.negotiationId
        state.hasMore = action.payload.hasMore
        state.currentPage = action.payload.page
        state.totalCount = action.payload.totalCount
        state.error = null

        if (action.payload.reset || action.payload.page === 1) {
          state.messages = action.payload.messages.reverse()
        } else {
          state.messages = [
            ...action.payload.messages.reverse(),
            ...state.messages,
          ]
        }
      })
      .addCase(fetchNegotiationHistoryAsync.rejected, (state, action) => {
        state.loading = false
        state.loadingMore = false
        state.error = action.payload as string
      })
  },
})

export const { resetMessages, setLoadingMore } = negotiationHistorySlice.actions
export default negotiationHistorySlice.reducer
